import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Logo from '../img/logo.png'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import LOG from '../logging/Logger'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '75%',
    maxHeight: '75%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '50%',
      maxHeight: '50%'
    }
  }
}))

export default () => {
  LOG.debug('Render: Zen')

  const classes = useStyles()
  const theme = useTheme()

  const xs = useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  })

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container alignItems='center' justifyContent='center' spacing={1}>
          <Grid item xs={12} sm={7}>
            <Typography align='center' variant={xs ? 'h5' : 'h6'}>
              Ah, the list is empty!
            </Typography>
            <Typography
              align='center'
              variant='subtitle1'
              color='textSecondary'
            >
              For now your work here is done
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <img className={classes.img} alt='Zen' src={Logo} />
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}
